import { FC } from 'react';
import { useFragment } from 'react-relay';
import { FieldArray } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import WhatToSeeBlocksFieldSections, {
  WhatToSeeBlocksFieldSectionsProps,
} from 'components/WhatToSeeBlocksFieldSections';

import { WhatToSeeBlocksField_blocksConnection$key } from '__generated__/WhatToSeeBlocksField_blocksConnection.graphql';
import { WhatToSeeBlocksField_whatToSee$key } from '__generated__/WhatToSeeBlocksField_whatToSee.graphql';

type Props = WhatToSeeBlocksFieldSectionsProps & {
  blocksConnection: WhatToSeeBlocksField_blocksConnection$key;
  whatToSee: WhatToSeeBlocksField_whatToSee$key;
};

const WhatToSeeBlocksField: FC<Props> = props => {
  const { blocksConnection, whatToSee, ...rest } = props;

  const blocksConnectionData = useFragment(
    graphql`
      fragment WhatToSeeBlocksField_blocksConnection on WhatToSeeBlockConnection {
        ...WhatToSeeBlocksFieldSections_blocksConnection
      }
    `,
    blocksConnection
  );

  const whatToSeeData = useFragment(
    graphql`
      fragment WhatToSeeBlocksField_whatToSee on WhatToSee {
        ...WhatToSeeBlocksFieldSections_whatToSee
      }
    `,
    whatToSee
  );

  return (
    <FieldArray name={rest.name}>
      {({ swap, push }) => (
        <WhatToSeeBlocksFieldSections
          blocksConnection={blocksConnectionData}
          whatToSee={whatToSeeData}
          swap={swap}
          push={push}
          {...rest}
        />
      )}
    </FieldArray>
  );
};

export default WhatToSeeBlocksField;
